import React from 'react';

import PageLoader from 'ui/PageLoader';

import PageTabsAccess from '../PageTabsAccess';
import Overview from './Overview';
import { installService, loadServices } from './services';
import configs from './types/configs';
import Access from 'ui/Access';
import { withAppContext } from '../AppContext';
import MainView from './types/common/MainView';

const OVERVIEW_TAB = {
    name: 'overview',
    label: 'Available Integrations',
    url: '/integrations/overview',
    component: Overview,
};

class Integrations extends React.Component {
    state = {
        loaded: false,
        services: [],
    };

    async componentDidMount() {
        const { updateBreadcrumbs } = this.props;
        updateBreadcrumbs(['Integrations', 'Overview']);

        try {
            const services = await loadServices();
            this.setState({ services, loaded: true });
        } catch (e) {
            console.warn(e);
            this.setState({ loaded: true });
        }
    }
    render() {
        const { loaded, services } = this.state;

        if (!loaded || !services) {
            return <PageLoader />;
        }
        const {
            app,
            history,
            match: {
                params: { tab },
            },
        } = this.props;
        const { currentUser, settings } = app;

        const editable = app.canChange(Access.INTEGRATIONS);
        const service = services.find(service => service.identifier === tab);
        const config = configs.find(config => config.name === tab);
        const onSelect = async ({ name }) => {
            if (await checkInstall(name)) {
                const url = `/integrations/${name}`;
                history.push(url);
            }
        };
        const onUpdate = async (redirect = false) => {
            if (redirect) {
                history.push('/integrations');
            }
            const services = await loadServices();
            this.setState({ services });
        };
        const isDummy = identifier => {
            const config = configs.find(config => config.name === identifier);
            return config && config.dummy;
        };
        const checkInstall = async identifier => {
            if (isDummy(identifier)) {
                return true;
            }
            if (!services.find(service => service.identifier === identifier)) {
                try {
                    const uuid = currentUser.organizations[0].uuid;
                    const data = await installService(uuid, identifier);
                    this.setState({ services: services.concat([data]) });
                } catch (e) {
                    console.warn(e);
                    return false;
                }
            }
            return true;
        };
        if (tab !== 'overview') {
            checkInstall(tab);
        }

        const showTab = item => {
            return (
                item.alwaysVisible ||
                (item.enabled &&
                    services.some(
                        service =>
                            service.identifier === item.name &&
                            service.extra &&
                            Object.values(service.extra).length
                    ))
            );
        };

        const tabs = [OVERVIEW_TAB].concat(
            configs
                .filter(item => item.enabled)
                .map(item => {
                    const { name, label } = item;
                    return {
                        name,
                        label,
                        url: `/integrations/${name}`,
                        component: MainView,
                        hidden: !showTab(item),
                    };
                })
        );

        return (
            <div>
                <PageTabsAccess
                    tab={tab}
                    tabs={tabs}
                    onChange={url => history.push(url)}
                    extra={{
                        config,
                        service,
                        configs,
                        services,
                        onSelect,
                        onUpdate,
                        editable,
                        settings,
                        history,
                    }}
                />
            </div>
        );
    }
}

export default withAppContext(Integrations);
